<script setup>
import { TARGET_PERIOD_ENTITY_KEYS } from '@/utils/entity-keys'

defineOptions({
  name: 'ProgressModuleGridFooter'
})

defineProps({
  periods: {
    type: Array,
    default: () => []
  },

  fillWeekends: {
    type: Boolean
  }
})
</script>

<template>
  <div class="pmgf-Footer">
    <div
      v-for="item in periods"
      :key="item[TARGET_PERIOD_ENTITY_KEYS.START_DATE]"
      :class="{
        'pmgf-Footer_Cell-with-fill': fillWeekends
      }"
      :style="{
        flex: item.duration
      }"
      class="pmgf-Footer_Cell"
    />
  </div>
</template>

<style lang="scss" scoped>
.pmgf-Footer {
  display: flex;
  height: 40px;
}

.pmgf-Footer_Cell {
  background-color: $white;

  &:not(:last-child) {
    box-shadow: inset calc(-1 * var(--cdpm-divider-size)) 0 0 var(--cdpm-divider-color);
  }

  &-with-fill {
    position: relative;

    &:after {
      content: '';
      pointer-events: none;
      position: absolute;
      right: var(--cdpm-divider-size);
      top: 0;
      height: 100%;
      width: calc(100% / 7) * 2;
      background: rgba($grey-3-next, 0.5);
    }
  }
}
</style>
